import { cloneDeep } from 'lodash';

const loading = (state, payload) => {
  const newState = cloneDeep(state);
  newState.loading = true;
  return newState;
};

export { loading };
